/**
 * Mock authentication for the POC chat app.
 *
 * NOTE: This is intentionally insecure — plaintext credentials in the
 * client bundle, no hashing, no database, no server round-trip. It exists
 * only so stakeholders can walk through the proof-of-concept. Replace with
 * a real auth flow before this ever leaves the demo stage.
 */

const MOCK_USERNAME = "admin";
const MOCK_PASSWORD = "demo";

const SESSION_KEY = "hatch_session";

export interface Session {
	username: string;
	authenticatedAt: number;
}

/** Attempt a mock login. Returns a Session on success, null on failure. */
export function login(username: string, password: string): Session | null {
	if (username.trim() === MOCK_USERNAME && password === MOCK_PASSWORD) {
		const session: Session = {
			username: MOCK_USERNAME,
			authenticatedAt: Date.now(),
		};
		try {
			sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
		} catch {
			/* sessionStorage may be unavailable (private mode); ignore */
		}
		return session;
	}
	return null;
}

/** Read the current session, if any. */
export function getSession(): Session | null {
	try {
		const raw = sessionStorage.getItem(SESSION_KEY);
		if (!raw) return null;
		return JSON.parse(raw) as Session;
	} catch {
		return null;
	}
}

/** True when a mock session exists. */
export function isAuthenticated(): boolean {
	return getSession() !== null;
}

/** Clear the session. */
export function logout(): void {
	try {
		sessionStorage.removeItem(SESSION_KEY);
	} catch {
		/* ignore */
	}
}
